import React from 'react'

const Imageform = () => {
  return (
    <div>
        <form>
                

                <input type="file" name="" id="" />


                <input type="submit" value="UPDATE"  className='update'/>

            
            
            </form>
    </div>
  )
}

export default Imageform